module.exports = __webpack_public_path__ + "img/DW_hxdw.09bd1994.jpg";